export const KNOWLEDGE_BASE = {
  PREBID_BIDDERS: 'https://knowledge-base.yieldbird.com/prebid-stack/demand-organization',
  URL_FILTERING: 'https://knowledge-base.yieldbird.com/prebid-stack/url-filtering',
  USER_MANAGEMENT: 'https://knowledge-base.yieldbird.com/yieldbird-platform/users-management',
} as const
